import { ProductsApiClient } from '@fourthwall/services/dist/ProductsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useProductQuery = createQueryHook(ProductsApiClient.getProduct, {
  queryKey: ['product'],
})
